const audioNodeMap = new WeakMap();

export function getSharedAudioNodes(audioElement) {
  if (audioNodeMap.has(audioElement)) {
    return audioNodeMap.get(audioElement);
  }
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  const context = new AudioContextClass();
  const source = context.createMediaElementSource(audioElement);
  source.connect(context.destination);
  const nodes = { context, source };
  audioNodeMap.set(audioElement, nodes);
  return nodes;
}

export function createAnalyserFromElement(audioElement, fftSize = 256) {
  try {
    const { context, source } = getSharedAudioNodes(audioElement);
    if (context.state === 'suspended') {
      context.resume();
    }
    const analyser = context.createAnalyser();
    analyser.fftSize = fftSize;
    analyser.smoothingTimeConstant = 0.8;
    source.connect(analyser);
    return { analyser, context };
  } catch (e) {
    console.warn('createAnalyserFromElement failed:', e.message);
    return null;
  }
}
